// extracted by mini-css-extract-plugin
module.exports = {"page":"xf","modal":"yf","actions":"zf","step":"Af","logos":"Bf","primary":"Cf","disabled":"Df","cancel":"Ef","bodyOpen":"Ff","primeLogo":"Gf","vipLogo":"Hf","plus":"If"};